import axios from "axios";

export default axios.create({
    //baseURL: "http://192.168.0.2:3001/admin/"
    baseURL: "https://api-ieaqui.avamobile.com.br/admin/"
});
